var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBorderDesktopWavyTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 64,
    viewBox: "0 0 1440 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M312 48.2625C503.25 48.2625 577.125 -30.0047 772.875 12.801C968.625 55.6068 1135.12 33.1547 1250.62 33.1547C1366.12 33.1547 1440 64 1440 64H0V12.8011C0 12.8011 120.75 48.2624 312 48.2625Z",
    fill: "#F5FFF7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorderDesktopWavyTop);
export default __webpack_public_path__ + "static/media/border-desktop-wavy-top.4a359dd0ec6c1a2a3b94a52cc374a6af.svg";
export { ForwardRef as ReactComponent };